import { StyledH2, mediaQuery } from 'components';
import styled from 'styled-components';

export const PageHeader = styled(StyledH2)`
  margin-bottom: 2rem;
  text-align: center;

  ${mediaQuery.medium`
    text-align: left;
    margin-top: 1rem;
  `}
`;
